import React from "react";
import { useParams } from "react-router-dom";

// import { TimeIcon } from "@chakra-ui/icons";
import { Box, Skeleton, Text } from "@chakra-ui/react";

import { useGetMeQuery } from "redux/services/apiService";
import { useGetMenusQuery } from "redux/services/menu";
import { isUserAuthenticated } from "redux/slices/user";
import { useAppSelector } from "redux/store";

import GoogleDataStudio from "components/GoogleDataStudio/GoogleDataStudio";
import SupersetEmbed from "components/SupersetEmbed/SupersetEmbed";
import Tableau from "components/Tableau/Tableau";
import { parseEmbedConfig } from "utils/embed";
// import { today } from "utils/constants";
import { decode } from "utils/hash";

type Props = {};
const DynamicDashboard: React.FC<Props> = (): JSX.Element => {
  const params = useParams();
  const { data: menus = [] } = useGetMenusQuery();
  const isAuthenticated = useAppSelector(isUserAuthenticated);

  const getDesc = (param) => {
    var desc = "";
    menus.some((m) =>
      m.children.some((c) => {
        if (c.name.replaceAll(" ", "-") === param) {
          desc = c.description;
        }
        return desc;
      })
    );
    return desc;
  };
  const { isLoading } = useGetMeQuery(undefined, {
    skip: !isAuthenticated,
  });

  const RenderEmbed = () => {
    const rawSource = decodeURIComponent(decode(params.source));
    const parsedConfig = parseEmbedConfig(rawSource);

    if (!parsedConfig) {
      return (
        <Text color="gray.500" textAlign="center" mt="10">
          Dashboard belum dikonfigurasi.
        </Text>
      );
    }

    if (parsedConfig.provider === "superset") {
      return (
        <SupersetEmbed
          dashboardId={parsedConfig.dashboardId}
          supersetDomain={parsedConfig.supersetDomain}
          height="900px"
        />
      );
    }

    if (parsedConfig.provider === "tableau") {
      return (
        <>
          <Tableau
            url={parsedConfig.source}
            containerId={params.source}
          />
        </>
      )
    }
    else if (parsedConfig.provider === "datastudio") {
      return (
        <>
          <GoogleDataStudio source={parsedConfig.source} />
        </>
      )
    } else {
      return (
        <>
          <iframe
            src={parsedConfig.source}
            title="media social embeded"
            style={{ overflow: "hidden", height: "900px", width: "100%" }}
            height="900px"
            width="100%"
          />
        </>
      )
    }

  }

  return (
    <Skeleton isLoaded={!isLoading}>
      <Box mt="4">
        {params?.source !== "bnVsbA==" ? (
          <Box>
            <RenderEmbed />
            {getDesc(params.menu) && getDesc(params.menu) !== null ? (
              <>
                <Text fontSize="15" fontWeight="bold" color="#C0392B" mt="2" mb="0">
                  Deskripsi:
                </Text>
                <Text fontSize="15" fontWeight="bold" color="#C0392B" mt="0">
                  {getDesc(params.menu)}
                </Text>
              </>
            ) : null}
          </Box>
        ) : (
          <Text fontSize="5xl" fontWeight="bold" color="#C0392B" textAlign="center" mt="20">
            Coming Soon!
          </Text>
        )}
      </Box>
    </Skeleton>
  );
};

export default DynamicDashboard;
